<template>
	<div class="contact-data-tab">
		<div class="flex flex-align-center flex-just-between">
			<div class="label">联系人</div>
			<el-button type="primary" @click="relevancePerson" v-if="$auth.hasPermi('system:talent:edit-talent') && isLoginPartner">{{
				isThread ? '建联' : '+ 关联联系人'
			}}</el-button>
		</div>
		<el-table class="mt-16" :data="anchorContactList" header-row-class-name="table-header-row" row-class-name="table-row">
			<el-table-column prop="shipping_sn" label="联系人信息" min-width="160">
				<template slot-scope="{ row }">
					<div class="">
						<contact-card :info="row" />
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="shipping_company" align="center" label="微信添加状态" min-width="80">
				<template slot-scope="{ row }">
					<span :class="['fz-12', row.is_add_wx === '1' ? 'success' : 'warning', 'des']">{{ row.is_add_wx === '1' ? '已加微信' : '未加微信' }}</span>
				</template>
			</el-table-column>
			<el-table-column prop="delivery_time" label="收货地址" min-width="160">
				<template slot-scope="{ row }">
					<div v-if="Array.isArray(row.delivery_info)"> 暂无 </div>
					<div v-else>
						<div class="fz-14 yx-color-text-primary">
							<span class="mr-10">{{ row.delivery_info.delivery_name }}</span>
							<span>{{ row.delivery_info.delivery_mobile }}</span>
						</div>
						<div class="fz-12 yx-color-text-regular">
							{{ row.delivery_info.province + row.delivery_info.city + row.delivery_info.area + row.delivery_info.delivery_addr }}
						</div>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="add_time" label="绑定时间" min-width="120"></el-table-column>
			<el-table-column label="操作" min-width="80" align="center">
				<template slot-scope="{ row }">
					<div>
						<p class="pointer yx-color-primary" @click="skinContact(row)">查看该联系人</p>
						<p class="pointer yx-color-primary" v-if="!Array.isArray(row.delivery_info)" @click="copyAddress(row)">复制地址 </p>
						<p class="pointer yx-color-primary" @click="editAddress(row)">编辑地址</p>
					</div>
				</template>
			</el-table-column>
		</el-table>
		<div class="label mt-24">来源</div>
		<div class="text">{{ anchorInfo.from_type }}</div>
		<addressDialog ref="addressDialog" @getList="getInfo"></addressDialog>
	</div>
</template>

<script>
import contactCard from '../contactCard';
import addressDialog from '../addressDialog';
import { getAnchorContactList } from '@/api/talentCRM';
export default {
	name: 'contactDataTab',
	props: {
		anchorId: {
			type: [String, Number],
			default: '',
		},
		anchorInfo: {
			type: Object,
			default: _ => ({}),
		},
		isLoginPartner: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		contactCard,
		addressDialog,
	},
	data() {
		return {
			anchorContactList: [],
		};
	},
	computed: {
		isThread() {
			return !this.anchorContactList.length;
		},
	},
	methods: {
		getInfo() {
			this.getAnchorContactList();
		},
		async getAnchorContactList() {
			const { code, data: { list = [] } = {} } = await getAnchorContactList({ anchor_id: this.anchorId });
			if (code !== 0) return;
			this.anchorContactList = list;
		},
		reset() {
			this.anchorContactList = [];
		},
		relevancePerson() {
			this.$emit(this.isThread ? 'showBuildContactDialog' : 'showLinkmanDialog');
		},
		editAddress({ delivery_info, contact_id }) {
			this.$refs.addressDialog.show(delivery_info, contact_id);
		},
		copyAddress({ delivery_info }) {
			let copy_value = `收件人：${delivery_info.delivery_name}\r\n收件电话：${delivery_info.delivery_mobile}\r\n收件地址：${
				delivery_info.province + delivery_info.city + delivery_info.area + delivery_info.delivery_addr
			}`;
			var inputTest = document.createElement('textarea');
			inputTest.value = copy_value;
			document.body.appendChild(inputTest);
			inputTest.select();
			document.execCommand('Copy');
			inputTest.className = 'oInput';
			inputTest.style.display = 'none';
			this.$message.success('复制成功');
			document.body.removeChild(inputTest);
		},
		//跳转到联系人
		skinContact({ contact_id }) {
			const routeLink = this.$router.resolve({
				path: '/talentCRM/contacts',
				query: {
					contact_id,
				},
			});
			window.open(routeLink.href, '_blank');
		},
	},
};
</script>

<style lang="less" scoped>
.contact-data-tab {
	padding: 0 0px 16px 12px;

	.label {
		font-size: 16px;
		color: #333;
		border-left: 4px solid #0053db;
		line-height: 20px;
		padding-left: 4px;
	}

	.person-wrap {
		margin-top: 16px;
		margin-bottom: 20px;
		display: grid;
		grid-template-columns: 303px 303px 303px;
		grid-column-gap: 20px;
	}

	.text {
		font-size: 16px;
		color: #333;
		font-weight: bold;
		margin-top: 16px;
	}

	.empty {
		font-size: 16px;
		color: #969799;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		margin-top: 50px;

		.i-contact {
			width: 240px;
			height: 240px;
		}
	}

	.success {
		border: 1px solid #9fe9a7;
		color: #0fb820;
	}

	.warning {
		border: 1px solid #fdd2a1;
		color: #fa8f14;
	}

	.des {
		display: inline-block;
		padding: 0px 4px;
		border-radius: 2px;
	}
}
</style>
